// Helpers do modulo de Estoque (aba Insumos). Os tipos de movimentacao vem do
// backend (GET /insumos/tipos-movimentacao); aqui fica so a apresentacao.

export function formatarCodigo(numero) {
  if (numero === null || numero === undefined) return '—';
  return String(numero).padStart(3, '0');
}

export function fmtNum(n) {
  if (n === null || n === undefined || n === '') return '—';
  return Number(n).toLocaleString('pt-BR', { maximumFractionDigits: 2 });
}

export function fmtDataHora(dt) {
  if (!dt) return { data: '—', hora: '' };
  const d = new Date(dt);
  return {
    data: d.toLocaleDateString('pt-BR'),
    hora: d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
  };
}

// Variacao com sinal de uma linha do extrato. Usa o saldo antes/depois quando
// existe (fonte da verdade); nas linhas antigas cai no sinal do tipo.
export function variacao(mov, tipos) {
  if (mov.estoque_anterior !== null && mov.estoque_anterior !== undefined
    && mov.estoque_resultante !== null && mov.estoque_resultante !== undefined) {
    return Number(mov.estoque_resultante) - Number(mov.estoque_anterior);
  }
  const sinal = tipos?.[mov.tipo]?.sinal ?? 0;
  return sinal ? sinal * Number(mov.quantidade) : Number(mov.quantidade);
}

export function fmtVariacao(v) {
  const n = Number(v);
  if (!n) return '0';
  return `${n > 0 ? '+' : '−'}${fmtNum(Math.abs(n))}`;
}

export function nomeProduto(p) {
  return [p.descricao ?? p.produto, p.marca_nome, p.modelo].filter(Boolean).join(' ');
}

const pad = (x) => String(x).padStart(2, '0');
const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// Periodos rapidos do painel e do extrato.
export function periodo(chave) {
  const hoje = new Date();
  if (chave === '7dias') {
    const de = new Date(hoje);
    de.setDate(de.getDate() - 6);
    return { de: iso(de), ate: iso(hoje) };
  }
  if (chave === 'mes') {
    return { de: iso(new Date(hoje.getFullYear(), hoje.getMonth(), 1)), ate: iso(hoje) };
  }
  if (chave === 'mes_anterior') {
    return {
      de: iso(new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1)),
      ate: iso(new Date(hoje.getFullYear(), hoje.getMonth(), 0)),
    };
  }
  return { de: iso(hoje), ate: iso(hoje) };
}

export const PERIODOS = [
  ['hoje', 'Hoje'],
  ['7dias', 'Últimos 7 dias'],
  ['mes', 'Este mês'],
  ['mes_anterior', 'Mês anterior'],
  ['personalizado', 'Personalizado'],
];

export const STATUS_PRODUTO = {
  ativo: { label: 'Ativo', pill: 'status-pill--ativo' },
  inativo: { label: 'Inativo', pill: 'status-pill--inativo' },
  descontinuado: { label: 'Descontinuado', pill: 'status-pill--cancelada' },
};
